<template>
    <div id="tutorial-wrapper">
        <section class="tutorial-text">
            <div class="label">{{ tutorialData[currentIndex].label }}</div>
            <div>{{ tutorialData[currentIndex].description }}</div>
        </section>
        <section class="tutorial-bg">
            <img class="tutorial-img" :alt="tutorialData[currentIndex].label" :src="tutorialData[currentIndex].icon" />
        </section>
        <footer class="tutorial-action-btns d-flex justify-content-center h-90">
            <button
                type="button"
                class="btn btn-light border border-secondary me-2 w-30 skip-btn"
                @click="handleSkipTutorial()"
            >
                Skip
            </button>
            <button type="button" class="btn btn-primary border border-primary w-30 next-btn" @click="handleNext()">
                {{ currentIndex === tutorialData.length - 1 ? "Finish" : "Next" }}
            </button>
        </footer>
    </div>
</template>

<script lang="ts" src="./ChatTutorial.ts"></script>
<style src="./ChatTutorial.scss"></style>
